import { membershipService } from '@libs/data-access/queries'
import {
  IconWrap,
  AlarmBellIcon,
  Indicator,
  DropdownMenu,
  BaseButton,
  Tooltip
} from '@libs/ui/ds'
import { useAppNavBarTranslation } from '@libs/utils/translations'
import type { FC } from 'react'

import { NotificationsDropdownMenuContent } from '../../../components/NotificationsNavItem/NotificationsDropdownMenuContent'

export const NotificationsDropdownMenu: FC = () => {
  const { t } = useAppNavBarTranslation()

  const membershipNotifications =
    membershipService.membership.notifications.useFetchNotifications(
      {
        queryParams: {
          reset_cache: true
        }
      },
      { enabled: false }
    )

  const onOpen = () => {
    membershipNotifications.refetch()
  }

  return (
    <DropdownMenu
      dropdownPosition='bottom-end'
      dropdownWidth='l'
      onOpen={onOpen}
    >
      <DropdownMenu.Target>
        <BaseButton
          data-testid='navbar-notification'
          className='cursor-pointer overflow-visible rounded-full bg-transparent px-2 py-1 text-neutral-75 hover:bg-neutral-700/60 active:bg-neutral-700'
        >
          <Tooltip label={t('notifications.title')}>
            <Indicator
              color='semantic.red'
              label={membershipNotifications.data?.total_count || '0'}
              position='top-end'
              size='xs'
              hide={!membershipNotifications.data?.total_count}
            >
              <IconWrap className='mt-1' icon={<AlarmBellIcon />} size='m' />
            </Indicator>
          </Tooltip>
        </BaseButton>
      </DropdownMenu.Target>

      <NotificationsDropdownMenuContent
        notifications={membershipNotifications.data}
        count={membershipNotifications.data?.total_count}
        isLoading={membershipNotifications.isPending}
      />
    </DropdownMenu>
  )
}
